import { uniqBy } from 'lodash/array'
import { handleActions } from 'redux-actions'
import { TWINNED_LOOK_TYPE, RECOMMENDATION_TYPES, INTERNAL_REF, STYLE_ADVISOR_TYPE, LOOK_ANNOTATED_TYPE, NEW_DETECTION_STR } from '../utils/constants'
import { generateUniqueId } from '../utils'
// import mockStyleAdvisorResults from '../components/PopupStyleAdvisor/mockResults'

const defaultState = {
  all: [],
  detection: {
    perfectMatch: ''
  },
  attributes: {},
  detections: [],
  jobs: [],
  categories: {},
  imageToShow: '',
  selected: {},
  annotationId: '',
  searchedProduct: {},
  similars: [],
  look: [],
  lookProducts: [],
  lookNoProducts: [],
  styleAdvisorResults: [],
  modalStyleAdvisorWasOpened: false,
  twinnedLooksResults: [],
  textSearchResults: []
}

exports.products = handleActions({
  RECOGNIZE_PRODUCTS_COMPLETED: (state, action) => {
    const detections = action.payload.detections || []

    detections.forEach((det) => {
      det.bbox = {
        y1: det.bbox.y1,
        x1: det.bbox.x1,
        x2: det.bbox.x2,
        y2: det.bbox.y2
      }
      det[INTERNAL_REF] = generateUniqueId()
    })

    const hasDetections = detections.length > 0
    return hasDetections ? {
      ...state,
      detection: detections[0],
      attributes: { results: [] },
      detections: uniqBy(detections, d => d.label)
    } : {
      ...state,
      attributes: { results: [] },
      detections: [],
      detection: {}
    }
  },

  SEARCH_PRODUCTS_RECEIVED: (state, action) => {
    let result = ''
    if (action.payload.errors && action.payload.errors.length > 0) {
      result = ({
        ...state,
        moreProductsErrors: action.payload.errors
      })
    }
    if (action.payload.results && action.payload.results.length > 0) {
      let products = action.payload.results
      if (state.moreProducts) {
        products = products.concat(state.moreProducts)
      }
      result = ({
        ...state,
        moreProducts: products
      })
    }
    return result
  },

  SEARCH_PRODUCTS_EMPTY: (state, action) => {
    return ({
      ...state,
      moreProductsErrors: [],
      moreProducts: []
    })
  },

  SEARCH_PRODUCT_RECEIVED: (state, action) => {
    let result = ''
    if (action.payload.results.length > 0) {
      result = ({
        ...state,
        searchedProduct: action.payload.results[0]
      })
    } else {
      if (action.payload.errors[0]) {
        result = ({
          ...state,
          searchedProduct: {errorMessage: action.payload.errors[0].message}
        })
      }
    }
    return result
  },

  SET_DETECTION: (state, action) => {
    const { detections } = state
    const { internal_ref: internalRef } = action.payload

    if (detections) {
      const detectionIndex = detections.findIndex(det => det.internal_ref === internalRef)
      const detection = detections[detectionIndex] || {}

      return {
        ...state,
        detection: detection,
        attributes: detection.attributes
      }
    } else {
      return {
        ...state,
        detection: {},
        attributes: {}
      }
    }
  },

  GET_CATEGORIES_COMPLETED: (state, action) => {
    return {
      ...state,
      categories: action.payload
    }
  },

  GET_JOBS_COMPLETED: (state, action) => {
    const jobs = action.payload.jobs.filter(j => j.type === 'bboxWeRecommendV2')
    return {
      ...state,
      jobs: jobs
    }
  },

  GET_IMAGE_TO_VALIDATE_COMPLETED: (state, action) => {
    return {
      ...state,
      imageToShow: action.payload
    }
  },

  SELECT_ALTERNATIVE_IMAGE_COMPLETED: (state, action) => {
    return {
      ...state,
      all: [],
      attributes: {results: []},
      imageToShow: action.payload,
      detections: []
    }
  },

  GET_ANNOTATIONS_COMPLETED: (state, action) => {
    const { annotations } = action.payload
    const { id, data } = annotations[0]
    const parsedData = JSON.parse(data)

    parsedData.results.forEach((det) => {
      det[INTERNAL_REF] = generateUniqueId()
    })

    return {
      ...state,
      annotationId: id,
      detection: { ...parsedData.results[0] },
      attributes: { results: [] },
      detections: [...uniqBy(parsedData.results, d => d.label)]
    }
  },

  DROP_RESULTS: (state, action) => {
    return {
      ...state,
      detection: {},
      all: '',
      attributes: {results: []},
      detections: []
    }
  },

  ADD_NEW_DETECTION: (state, action) => {
    const {internal_ref, label, perfectMatch} = action.payload
    let newDetection = {
      internal_ref: internal_ref,
      bbox: state.detection.bbox,
      label,
      perfectMatch,
      point: {x: 0, y: 0}
    }

    return {
      ...state,
      detections: [...state.detections, newDetection],
      detection: newDetection,
      attributes: {results: []}
    }
  },

  SEARCH_BY_IMAGE_COMPLETED: (state, action) => {
    const bbox = action.payload.data.bboxes[0]
    const results = action.payload.results

    return {
      ...state,
      all: results,
      attributes: action.payload.attributes,
      detection: {
        ...state.detection,
        bbox: bbox
      },
      detections: state.detections.map((d) =>
        d.internal_ref === state.detection.internal_ref ? {
          ...d,
          bbox: bbox,
          results: results
        } : d
      )
    }
  },

  GET_SIMILARS_COMPLETED: (state, action) => {
    // we slice the similars because there are more than 100
    return {
      ...state,
      similars: action.payload.results.slice(Math.max(action.payload.results.length - 120, 1))
    }
  },

  GET_LOOK_COMPLETED: (state, action) => {
    return {
      ...state,
      look: action.payload.results
    }
  },

  GET_LOOK_PRODUCTS_COMPLETED: (state, action) => {
    const lookNoProducts = action.payload.lookNoProducts || [];
    return {
      ...state,
      lookProducts: action.payload.results,
      lookNoProducts: lookNoProducts
    }
  },

  GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED: (state, action) => {
    console.log('GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED!', action)
    const {results} = action.payload

    // Use it if you need to test the SA results
    // const mockedResults = results.length ? results : mockStyleAdvisorResults.results;
    return {
      ...state,
      styleAdvisorResults: results,
      modalStyleAdvisorWasOpened: true
    }
  },

  GET_ANNOTATION_FROM_STYLE_ADVISOR_FAILED: (state, action) => {
    return {
      ...state,
      styleAdvisorResults: [],
      modalStyleAdvisorWasOpened: false
    }
  },

  GET_TWINNED_LOOKS_COMPLETED: (state, action) => {
    console.log('GET_TWINNED_LOOKS_COMPLETED!', action)
    const {result} = action.payload
    return {
      ...state,
      twinnedLooksResults: result
    }
  },

  GET_TWINNED_LOOKS_FAILED: (state, action) => {
    console.log('GET_TWINNED_LOOKS_FAILED!', action)
    return {
      ...state,
      twinnedLooksResults: []
    }
  },

  GET_TEXT_SEARCH_COMPLETED: (state, action) => {
    console.log('GET_TEXT_SEARCH_COMPLETED!', action)
    const {results} = action.payload
    return {
      ...state,
      textSearchResults: results
    }
  },

  GET_TEXT_SEARCH_FAILED: (state, action) => {
    console.log('GET_TEXT_SEARCH_FAILED!', action)
    return {
      ...state,
      textSearchResults: []
    }
  },

  TEXT_SEARCH_RESET_RESULTS: (state, action) => {
    console.log('TEXT_SEARCH_RESET_RESULTS!', action)
    return {
      ...state,
      textSearchResults: []
    }
  },

  REMOVE_DETECTION: (state, action) => {
    let newDetections = state.detections.filter((item) => action.payload.data.detection !== item)

    return ({
      ...state,
      detections: newDetections,
      detection: Object.assign({}, newDetections[0] || '')
    })
  },

  UPDATE_BBOX_DETECTION: (state, action) => {
    console.log('UPDATE_BBOX_DETECTION: ', action)
    const { bbox } = action.payload
    const { detection, detections } = state
    return {
      ...state,
      detection: {
        ...detection,
        bbox: bbox
      },
      detections: detections.map((d) =>
        d.internal_ref === detection.internal_ref ? {
          ...d,
          bbox: bbox
        } : d
      )
    }
  },

  SELECT_PRODUCT: (state, action) => {
    const { selectedProduct } = action.payload
    const { uid, category } = selectedProduct

    const newDetection = {
      perfectMatch: uid,
      label: `${category.name} (${uid})`
    }

    return {
      ...state,
      selected: selectedProduct,
      detections: state.detections.map((d) =>
        state.detection.internal_ref === d.internal_ref ? { ...d, ...newDetection } : d
      ),
      detection: {
        ...state.detection,
        ...newDetection
      }
    }
  },

  SELECT_LOOK: (state, action) => {
    let {annotationType, lookProducts, lookNoProducts} = action.payload
    const { searchedProduct } = state
    lookNoProducts = lookNoProducts || [];
    let noProductDetections = []

    if (TWINNED_LOOK_TYPE === annotationType) {
      const twinnedLook = lookProducts // add context

      // 1. Find the product uid of the twinned look and remove it
      lookProducts = twinnedLook.products.filter(prd => prd.uid !== twinnedLook.uid)

      // 3. Add the main look's product to the annotation
      lookProducts.unshift(searchedProduct)
    } else if (STYLE_ADVISOR_TYPE === annotationType) {
      // Add the main look's product to the annotation
      lookProducts.unshift(searchedProduct)
    }

    const firstPositionInternalRef = generateUniqueId()
    const createDetection = (product, isFirst) => {
      const internalRef = isFirst ? firstPositionInternalRef : generateUniqueId()
      return {
        internal_ref: internalRef,
        label: product.uid,
        perfectMatch: product.uid,
        bbox: product.images[0].bbox
      }
    }
    // Add NO Annotations to the selected detections list
    if (LOOK_ANNOTATED_TYPE === annotationType) {
      noProductDetections = lookNoProducts.map(product => ({
        internal_ref: generateUniqueId(),
        label: product.noCategory,
        perfectMatch: NEW_DETECTION_STR,
        bbox: {}
      }));
    }

    return {
      ...state,
      selected: lookProducts[0],
      detections: [...lookProducts.map((product, i) => createDetection(product, i === 0)), ...noProductDetections],
      detection: createDetection(lookProducts[0], true)
    }
  },

  SET_PERFECT_MATCH: (state, action) => {
    const { detections, detection } = state
    const { perfectMatch } = action.payload.data
    const createDetection = (detection, perfectMatch) => {
      return {
        ...detection,
        perfectMatch: perfectMatch,
        label: perfectMatch
      }
    }

    return {
      ...state,
      detections: detections.map((d) =>
        d.internal_ref === detection.internal_ref ? createDetection(d, perfectMatch) : d
      ),
      detection: createDetection(detection, perfectMatch)
    }
  },

  GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_COMPLETED: (state, action) => {
    return {
      ...state,
      lookProducts: action.payload.result
    }
  },

  GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED: (state, action) => {
    console.log('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED!', action)
    return {
      ...state,
      lookProducts: []
    }
  },

  SET_ANNOTATION_RECOMMEND_TYPE: (state, action) => {
    const {detections} = state
    const {data} = action.payload
    return {
      ...state,
      detections: detections.map((detection) => {
        const {perfectMatch, internal_ref: internalRef} = detection
        if (perfectMatch in data) {
          return {
            ...detection,
            recommend_type: data[perfectMatch]
          }
        } else if (internalRef in data) {
          return {
            ...detection,
            recommend_type: data[internalRef]
          }
        } else {
          return detection
        }
      })
    }
  },

  SET_NO_CATEGORY_RECOMMEND_TYPE: (state, action) => {
    return {
      ...state,
      detections: state.detections.map((detection) => {
        if (detection.perfectMatch in action.payload.data && detection.recommend_type === RECOMMENDATION_TYPES.NO.value) {
          return {
            ...detection,
            no_category: action.payload.data[detection.perfectMatch]
          }
        } else if (detection.internal_ref in action.payload.data && detection.recommend_type === RECOMMENDATION_TYPES.NO.value) {
          return {
            ...detection,
            no_category: action.payload.data[detection.internal_ref]
          }
        } else {
          const { no_category, ...restOfDetection } = detection
          return restOfDetection
        }
      })
    }
  }

}, defaultState)



// WEBPACK FOOTER //
// ./src/reducers/products.js